import { PortalDialogProps } from "@app/services/modal.service";
import { formatMoneyVN } from "@app/utils/util";
import Button from "../button";
import Modal from "../modal/modal.component";

interface PurchaseMediaConfirmModalProps {
  bookName: string;
  mediaLabel: string;
  currentKas: number;
  requiredKas: number;
}

function PurchaseMediaConfirmModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<PurchaseMediaConfirmModalProps>) {
  const currentKas = portalData?.currentKas ?? 0;
  const requiredKas = portalData?.requiredKas ?? 0;
  const isEnoughKas = currentKas >= requiredKas;

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="w-[460px] py-7 px-6">
        <div className="text-[28px] leading-[34px] text-center font-bold font-[SVN-Gilroy] text-[#171A20]">
          Xác nhận mua sách
        </div>
        <div className="mt-8 rounded-3xl bg-[#F6F8FC] px-5 py-4 text-[#3A4251]">
          <div className="flex items-start justify-between gap-4 border-b border-[#DFE2E7] pb-3">
            <span className="font-medium">Sách muốn mua</span>
            <span className="max-w-[220px] text-right font-semibold text-[#171A20]">
              {portalData?.bookName} ({portalData?.mediaLabel})
            </span>
          </div>
          <div className="mt-3 flex items-center justify-between gap-4 border-b border-[#DFE2E7] pb-3">
            <span className="font-medium">Kas hiện tại</span>
            <span className="font-semibold text-[#38499B]">
              {formatMoneyVN(currentKas)} kas
            </span>
          </div>
          <div className="mt-3 flex items-center justify-between gap-4">
            <span className="font-medium">Cần thanh toán</span>
            <span className="font-semibold text-[#FF7029]">
              {formatMoneyVN(requiredKas)} kas
            </span>
          </div>
        </div>
        <div className="mt-5 text-center text-sm leading-6 font-medium text-[#6C7482]">
          {isEnoughKas
            ? "Nhấn Xác nhận để hoàn tất mua sách bằng Kas."
            : "Số Kas hiện tại không đủ. Nhấn Xác nhận để tới màn nạp Kas."}
        </div>
        <div className="mt-8 flex justify-center gap-4">
          <Button
            size="xs"
            label="Hủy"
            theme="secondary"
            width={190}
            className="!h-[48px] !leading-[48px] !rounded-[24px] font-semibold"
            onClick={portalDialogRef.close}
          />
          <Button
            size="xs"
            label="Xác nhận"
            width={190}
            className="!h-[48px] !leading-[48px] !rounded-[24px] font-semibold bg-gradient-to-b from-[#8092e4] to-[#38499b]"
            onClick={() =>
              portalDialogRef.close({
                isAccept: true,
                isEnoughKas,
              })
            }
          />
        </div>
      </div>
    </Modal>
  );
}

export default PurchaseMediaConfirmModal;
